import gql from "@apollo/client";

const MOBILE_OFFERED_TARIFFS = gql`
	query TariffsOffered($region_url: String, $limitProvider: Int, $providerJoin: Boolean) {
		tariffsOffered(
			region_url: $region_url
			limitProvider: $limitProvider
			providerJoin: $providerJoin
		) {
			data {
				id
				name
				displayPrice
				mobile_new {
					internet
					calls
					sms
					internet_type
					calls_type
					sms_type
					tag_mobil {
						description
						name
						translit
					}
				}
				provider {
					id
					name
					logo
					logo_2
					url_name
					vip_provider
					contacts {
						card
						link
						phones
					}
					global {
						id
					}
					operator_settings {
						tariffs {
							value
							url
							button_text
						}
					}
				}
				exclusives {
					id
					name
					description
					image_24
				}
				connection {
					price
					time
				}
				dody {
					image_24px
					name
					short_description
					comment_tariff
					state
				}
				region {
					id
					url
				}
				internet {
					icon
					type {
						id
						name
					}
					speed_in
					include_trafic_metrics {
						id
						name
					}
					include_trafic_interval {
						id
						name
					}
					include_trafic_value
					excess_speed_in
					excess_speed_out
				}
				tv {
					channels
					channels_hd
					use_text
				}
				price {
					license_fee
					license_fee_month
					system_calculation_connect
					license_fee_interval {
						code
						name
						name_short
					}
				}
				after {
					rule {
						code
						value
						month_cnt
						date_end
					}
					change {
						code
						name
						id
					}
					data {
						price {
							license_fee
							license_fee_month
						}
						internet {
							type {
								id
								name
							}
							speed_in
							include_trafic_metrics {
								id
								name
							}
							include_trafic_interval {
								id
								name
							}
							include_trafic_value
							excess_speed_in
							excess_speed_out
						}
					}
				}
				utm_url
			}
		}
	}
`;

export default MOBILE_OFFERED_TARIFFS;
